import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

export interface DashboardMetrics {
  // Key Metrics
  assets_in_stock_count: number;
  assets_on_hr_count: number;
  total_hr_holders: number;
  assets_in_stock_value: number;
  assets_on_hr_value: number;
  // Alerts
  reorder_alert_count: number;
  approaching_reorder_count: number;
  overdue_thr_count: number;
  open_documents_count: number;
  open_orders_count: number;
}

/**
 * Fetches aggregated dashboard metrics for the IEM Key Metrics section.
 * Returns counts and dollar values for assets in stock vs on hand receipts.
 */
export const useDashboardMetrics = () => {
  return useQuery({
    queryKey: ['dashboard-metrics'],
    queryFn: async (): Promise<DashboardMetrics> => {
      // PostgREST returns an array; we expect exactly one row from the view
      const result = await httpClient.get<DashboardMetrics[]>(
        '/api/rest/data/v1/dashboard_metrics',
      );
      const row = result?.[0];
      if (!row) {
        // Return zeros if no data (shouldn't happen, but defensive)
        return {
          assets_in_stock_count: 0,
          assets_on_hr_count: 0,
          total_hr_holders: 0,
          assets_in_stock_value: 0,
          assets_on_hr_value: 0,
          reorder_alert_count: 0,
          approaching_reorder_count: 0,
          overdue_thr_count: 0,
          open_documents_count: 0,
          open_orders_count: 0,
        };
      }
      return row;
    },
    staleTime: 60 * 1000, // 1 minute - dashboard metrics can be slightly stale
  });
};
